module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "list",
    staticClass: "list-hack"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pullState > 0 && _vm.mode === 'swipeDown'),
      expression: "pullState>0&&mode==='swipeDown'"
    }],
    staticClass: "down-fresh"
  }, [_c('p', [_c('i', {
    staticClass: "icon iconfont icon-loading",
    class: [
      _vm.isloading ? 'loading' : ''
    ]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notice[_vm.pullState]))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pullState > 0 && _vm.mode === 'swipeUp'),
      expression: "pullState>0&&mode==='swipeUp'"
    }],
    staticClass: "up-fresh"
  }, [_c('p', [_c('i', {
    staticClass: "icon iconfont icon-loading",
    class: [
      _vm.isloading ? 'loading' : ''
    ]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notice[_vm.pullState]))])])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df866696!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/list.vue
// module id = 19
// module chunks = 8 11 13 14